import styled from 'styled-components';

export const CategoryListStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
`;

export const CategoriesListContainer = styled.ul<{ rows: number }>`
  display: flex;
  flex-direction: column;
  column-gap: 20px;
  list-style-type: none;
  padding: 0;
  margin: 0;
  position: relative;
`;
